import { render, staticRenderFns } from "./SubjectEdit.vue?vue&type=template&id=d38533da"
import script from "../../controllers/subject/subject-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/subject/subject-edit.js?vue&type=script&lang=js&external"
import style0 from "./SubjectEdit.vue?vue&type=style&index=0&id=d38533da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports